import { IError } from "../types/interface/demanderAvenant";

export const showErrorValuesDefault = {
    contratId: false,
    typeContrat: false,
    message: false,
    termeAvenantId: false,
    agence: false,
};
  
export const showErrorValuesSubmit = {
    contratId: true,
    typeContrat: true,
    message: true,
    termeAvenantId: true,
    agence: true,
};
  
export const defaultValues: IError = {
    contratId: '',
    typeContrat: '',
    message: '',
    termeAvenantId: '',
    agence: '',
};

export const TitleLabels = {
    contractant: {
      contratId: '',
      typeContrat: '',
      message: 'Votre message',
      termeAvenantId: 'Type de demande',
    },
};
